module.exports = __webpack_public_path__ + "img/deposit1.31cf9b66.jpg";